import queryApi from "../api/queryApi";

const QUERY_URL = '/api/public/query';

export const fetchDocAction = async (doc_type, auth) => {
    try {

        const actionData = {
            "query": {
                "id": "DOC_ACTION_REF",
                "source": "DOC_ACTION_REF",
                "fields": [
                    {"column": "action", /*"format": "number", "type": "number"*/},
                    {"column": "name", /*"format": "text", "type": "text"*/},
                ],
                "filters": [{
                    "column": "doc_type",
                    "operator": "=",
                    "value": doc_type,
                    "dataType": "text"
                }]
            }
        }

        const {data} = await queryApi.post(QUERY_URL,
            (actionData));

        const dataform = data.map(row => ({
                key: row.action,
                label: row.name
            })
        )
        return dataform

    } catch (error) {
        console.error('Error fetching itemsAction:', error);
    }

}

